var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1428 -6.10352e-05H2.85711C1.28168 -6.10352e-05 -3.05176e-05 1.28165 -3.05176e-05 2.85708V21.1428C-3.05176e-05 22.7182 1.28168 23.9999 2.85711 23.9999H21.1428C22.7183 23.9999 24 22.7182 24 21.1428V2.85708C24 1.28165 22.7183 -6.10352e-05 21.1428 -6.10352e-05ZM18.8605 10.4702C18.7295 10.483 18.5979 10.4896 18.4663 10.4902C17.7554 10.4903 17.0556 10.3134 16.4302 9.97539C15.8048 9.6374 15.2734 9.14898 14.884 8.55422V15.1468C14.884 16.1105 14.5982 17.0526 14.0628 17.8538C13.5274 18.6551 12.7664 19.2797 11.8761 19.6485C10.9857 20.0173 10.006 20.1138 9.06081 19.9257C8.11562 19.7377 7.24741 19.2737 6.56597 18.5922C5.88453 17.9108 5.42046 17.0426 5.23245 16.0974C5.04444 15.1522 5.14094 14.1725 5.50973 13.2821C5.87852 12.3918 6.50305 11.6308 7.30434 11.0954C8.10563 10.56 9.0477 10.2742 10.0114 10.2742C10.1131 10.2742 10.2125 10.2834 10.3125 10.2897V12.6908C10.2125 12.6788 10.1143 12.6605 10.0114 12.6605C9.35184 12.6605 8.7193 12.9225 8.25292 13.3889C7.78655 13.8553 7.52454 14.4878 7.52454 15.1474C7.52454 15.8069 7.78655 16.4395 8.25292 16.9058C8.7193 17.3722 9.35184 17.6342 10.0114 17.6342C11.3851 17.6342 12.5983 16.5519 12.5983 15.1782L12.6223 3.98165H14.9194C15.0244 4.97976 15.4768 5.90922 16.1977 6.60751C16.9185 7.3058 17.8619 7.72848 18.8628 7.80165V10.4702"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.1058ce2d.svg";
export { ForwardRef as ReactComponent };